import { Box, Flex, Text } from '@chakra-ui/react';
import { faTag } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, useToast } from '@morressier/alembic';
import { removeWorkspaceTag } from 'src/api/mutations';

interface Props {
  deleteTagId: string;
  usage: 'submissions' | 'users';
  onClose: () => void;
  workspaceId: string;
}
const DeleteTag: React.FC<Props> = ({
  deleteTagId,
  usage,
  onClose,
  workspaceId
}) => {
  const DeleteTagMutation = removeWorkspaceTag(workspaceId);
  const toast = useToast();
  const onDelete = async () => {
    const res = await DeleteTagMutation.mutateAsync(deleteTagId);
    if (res.isSuccess) {
      toast({
        variant: 'success',
        title: `Tag Deleted`,
        description:
          usage === 'submissions'
            ? 'This tag will still be visible on all archived Submissions.'
            : ''
      });

      return onClose();
    }
    return toast({
      variant: 'error',
      title: res.message
    });
  };
  return (
    <Modal
      isOpen={!!deleteTagId}
      onClose={onClose}
      width={{ base: 'calc(100vw - 16px)', md: '450px' } as any}
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex
        flexDirection={'column'}
        gap={4}
        padding={{ base: 4, md: 8 }}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box fontSize="40px" color={'actionSecondaryCautionContent'}>
          <FontAwesomeIcon icon={faTag} fontSize="42px" />
        </Box>
        <Text textStyle="headingGroup">Delete Tag from Workspace?</Text>
        <Text textStyle="textBody" textAlign={'center'}>
          This Tag will be permanently removed from your workspace. It will
          still be visible on all archived submissions. Are you sure you want to
          delete this Tag?
        </Text>
        <Flex flexDirection={'column'} gap={2} width="100%">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="caution" onClick={onDelete}>
            Delete Tag
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default DeleteTag;
